<template>
  <div :class="classes" style="position: relative" role="tree" onselectstart="return false" id="dwui-tree-wrapper">
    <ul :class="containerClasses" role="group" id="dwui-tree-container">
      <tree-item v-for="(child) in filteredData"
                 :key="child[nodeIdentifyFieldName]"
                 :searchText="searchText"
                 :hiddenSearchMiss="hiddenSearchMiss"
                 :infoIconHoverTitle="infoIconHoverTitle"
                 :cacheEnable="cacheEnable"
                 :cacheScope="cacheScope"
                 :node-identify-field-name="nodeIdentifyFieldName"
                 :childTreeItemMarginLeft="childTreeItemMarginLeft"
                 :supportNodeTypes="allNodeTypes"
                 :activeNodeItemIdentify="activeNodeItemIdentify"
                 :showRightInfoIcon="showRightInfoIcon"
                 :showEmptyExpand="showEmptyExpand"
                 :showExpandIcon="showExpandIcon"
                 :showNodeTypeIcon="showNodeTypeIcon"
                 :itemMenuData="child"
                 :cacheOpenTreeItems="cacheOpenTreeItems"
                 :menuTag="child[nodeIdentifyFieldName]"
                 :contextMenu="contextMenu"
                 :contextMenuOption="contextMenuOption"
                 :menuList="child.menuList ? child.menuList: []"
                 :text-field-name="textFieldName"
                 :value-field-name="valueFieldName"
                 :parentFieldName="parentFieldName"
                 :children-field-name="childrenFieldName"
                 :item-events="itemEvents"
                 :whole-row="wholeRow"
                 :show-checkbox="showCheckbox"
                 :allow-transition="allowTransition"
                 :height="sizeHeight"
                 :parent-item="data"
                 :draggable="draggable"
                 :drag-over-background-color="dragOverBackgroundColor"
                 :onItemDblclick="onItemDblclick"
                 :on-item-click="onItemClick"
                 :on-item-drag-start="onItemDragStart"
                 :on-item-drag-end="onItemDragEnd"
                 :on-item-drop="onItemDrop"
                 :onItemInfoClickCallback="onItemInfoClick"
                 @item-toggle="onItemToggle($event)"
                 @context-menu-click="onContextMenuClick($event)"
      >
        <template slot-scope="_">
          <slot :vm="_.vm" :model="_.model">
              <i :class="_.vm.themeIconClasses" role="presentation" v-if="decideShowNodeTypeIcon(_.model)"></i>
              <i v-if="!decideShowNodeTypeIcon(_.model)" class="empty-icon-fill" ></i>
            <span v-if="showShareLabel && _.model[shareFieldName]" :class="{'tree-item-shared-empty-expand' : showEmptyExpand, 'tree-item-shared': !showEmptyExpand}">{{shareLabelContent}}</span>
              <span v-html="_.model[textFieldName]"></span>
              <span v-if="_.model.nodeType === 'folder' && hiddenSearchMiss" >({{ _.model.matchLength }})</span>
          </slot>
        </template>
      </tree-item>
    </ul>
  </div>
</template>
<script>
import TreeItem from './tree-item.vue'
import { getOpenTreeItem, setOpenTreeItem } from '../lib/localStorage'

let ITEM_ID = 0
let ITEM_HEIGHT_SMALL = 18
let ITEM_HEIGHT_DEFAULT = 24
let ITEM_HEIGHT_LARGE = 32
export default {
  name: 'tree',
  props: {
    /**
     * 悬浮i 图标title
     */
    infoIconHoverTitle: {
      type: String,
      default: '显示详情'
    },
    scrollIntervalMilliSecond: {
      type: Number,
      default: 1000
    },
    value: {
      type: [String, Number],
      default: -1
    },
    hiddenSearchMiss: {
      type: Boolean,
      default: false
    },
    dragSuggest: {
      type: Boolean,
      default: false
    },
    treeType: {
      type: String,
      default: ''
    },
    /**
     * 缓存数据的scope,标识只有该scope下面的数据有效，例如不同用户传入不用的用户名用来区分各自的缓存数据
     */
    cacheScope: { type: String, default: '' },
    /*
    是否开启缓存，开启缓存后会记录节点的展开状态
    */
    cacheEnable: { type: Boolean, default: false },
    /*
    当节点前无图标时，是否展示空白占位符，以便保持父子节点的层级感觉
     */
    showEmptyExpand: { type: Boolean, default: false },
    /*
    支持搜索的字符串
    */
    searchText: { type: String, default: '' },
    /*
    树的基本类型
    */
    basicType: { type: String, default: '' },
    /*
    tree 组件绑定的数据，需要传入数组，数组结构符合父子层级关系
    */
    data: { type: Array },
    /*
    是否显示节点类型对应的标签
    */
    showNodeTypeIcon: {
      type: Boolean,
      default: true
    },
    /*
    子节点相对于父子点往左侧的偏移量，这个值决定父子层级结构的直观感觉
    */
    childTreeItemMarginLeft: {
      type: Number,
      default: 15
    },
    /*
    是否显示分享图标，当节点数据中包含[shareFieldName] 指定的属性值，且为true时显示
    */
    showShareLabel: { type: Boolean, default: false },
    /*
    分享效果显示的文字，这里s 代表英文share
    */
    shareLabelContent: { type: String, default: 's' },
    /*
    指定节点属性中哪个值作为分享字段
    */
    shareFieldName: { type: String, default: 'isShared' },
    /*
    是否开启右键菜单
    */
    contextMenu: { type: Boolean, default: false },
    /*
    节点类型
    */
    nodeType: { type: Array, default: () => [] },
    /*
    是否响应自定拖拽，这里指拖拽后需要请求接口进行交互
    */
    responseServerDrag: { type: Boolean, default: false },
    /*
    上下文菜单的属性设置
    */
    contextMenuOption: {
      type: Object,
      default () {
        return {
          underline: true,
          arrow: true,
          userCustomerIcon: false
        }
      }
    },
    /*
    组件树是否支持所包含容器的全部高度
    */
    isFullHeight: { type: Boolean, default: false },
    /*
    大小设置
    */
    size: { type: String, validator: value => ['large', 'small'].indexOf(value) > -1 },
    /*
    是否显示checkbox 框
    */
    showCheckbox: { type: Boolean, default: false },
    wholeRow: { type: Boolean, default: false },
    /*
    父子节点之间是否有 .... 连接
    */
    noDots: { type: Boolean, default: false },
    /*
    是否可折叠
    */
    collapse: { type: Boolean, default: false },
    /*
    是否支持多选
    */
    multiple: { type: Boolean, default: false },
    allowBatch: { type: Boolean, default: false },
    allowTransition: { type: Boolean, default: true },
    /*
    节点唯一性标识的属性名(节点身份属性)，即节点数据中哪个字段能够唯一标识当前节点是不同于其他节点的，这个属性值很重要
    */
    nodeIdentifyFieldName: { type: String, default: 'menuTag' },
    /*
    节点显示的文本对应的属性名，即显示时节点文本根据此属性名从节点数据中取值
    */
    textFieldName: { type: String, default: 'text' },
    valueFieldName: { type: String, default: 'value' },
    /*
    父节点字段名，通过当前节点该字段名可以获取父节点的引用
    */
    parentFieldName: { type: String, default: 'parent' },
    /*
    子节点对应的属性名
    */
    childrenFieldName: { type: String, default: 'children' },
    /*
    支持的事件
    */
    itemEvents: {
      type: Object,
      default: function () {
        return {}
      }
    },
    /*
    父节点下的子节点排序函数，当父子点下面的子节点排序发生变化时，则会回调这个函数进行排序
    */
    nodeSortFunction: { type: Function, default () { return () => {} } },
    /*
    是否支持异步加载
    */
    async: { type: Function },
    /*
     异步加载时loading 效果显示的文本
    */
    loadingText: { type: String, default: 'Loading...' },
    /*
    节点是否支持拖拽，这里是一个全局设置,当这个值为true时，节点数据中如果有(dropDisabled/dragDisabled)两个属性值
    且此值为false时，节点拖拽依然被禁止，这样的属性规则能精确控制到每个节点是否被拖拽
    */
    draggable: { type: Boolean, default: false },
    /*
    节点拖拽时的背景颜色
    */
    dragOverBackgroundColor: { type: String, default: '#C9FDC9' },
    /*
    是否显示节点右侧i 标记
    */
    showRightInfoIcon: { type: Boolean, default: false },
    /*
    是否显示展开图表
    */
    showExpandIcon: { type: Boolean, default: true },
    klass: String
  },
  data () {
    return {
      /**
       用于渲染的数据
       */
      filteredData: this.data,
      /**
       当前激活的节点的标识，这个由[nodeIdentifyFieldName]字段属性值决定
       */
      activeNodeItemIdentify: 0,
      /*
      缓存节点被打开的状态
      */
      cacheOpenTreeItems: [],
      /**
       表示正在被拖动的节点
       * */
      draggedItem: undefined,
      draggedElm: undefined,
      dragOriNode: undefined,
      /*
      表示拖动后放置的目标节点(即包容draggedItem的容器节点)
      */
      dragOriItem: undefined,
      selectedItem: undefined,
      defaultNodeType: [
        { nodeType: 'folder', iconClass: 'iconfont icon-floder', iconSize: '1em', iconColor: '' },
        { nodeType: 'file', iconClass: 'iconfont icon-file', iconSize: '1em', iconColor: '' },
        { nodeType: 'stream', iconClass: 'iconfont icon-StreamStudio icon-stream-color', iconSize: '1em', iconColor: 'green' },
        { nodeType: 'sql-file', iconClass: 'iconfont icon-sql icon-sql-color', iconSize: '1em', iconColor: 'green' },
        { nodeType: 'java-file', iconClass: 'iconfont icon-java- icon-java-color', iconSize: '1em', iconColor: 'green' },
        { nodeType: 'python-file', iconClass: 'iconfont icon-languagepythontext icon-python-color', iconSize: '1em', iconColor: 'green' },
        { nodeType: 'spark-file', iconClass: 'iconfont icon-apache_spark-ar icon-spark-color', iconSize: '1em', iconColor: 'green' },
        { nodeType: 'hive-file', iconClass: 'iconfont icon-HIVE2 icon-hive-color', iconSize: '1em', iconColor: 'green' },
        { nodeType: 'js-file', iconClass: 'iconfont icon-socialjavascriptoutline icon-js-color', iconSize: '1em', iconColor: 'green' },
        { nodeType: 'scala-file', iconClass: 'iconfont icon-scala icon-scala-color', iconSize: '1em', iconColor: 'green' },
        { nodeType: 'shell-file', iconClass: 'iconfont icon-shell icon-shell-color', iconSize: '1em', iconColor: 'green' }
        // { nodeType: 'python-project', iconClass: 'iconfont icon-leimu-yonghuPython', iconSize: '1em', iconColor: 'green' },
        // { nodeType: 'python-lib', iconClass: 'iconfont icon-folder-python icon-folder-python-color', iconSize: '1em', iconColor: 'green' }
      ]
    }
  },
  computed: {
    classes () {
      return [
        { 'tree': true },
        { 'tree-default': !this.size },
        { [`tree-default-${this.size}`]: !!this.size },
        { 'tree-checkbox-selection': !!this.showCheckbox },
        { 'full-height': this.isFullHeight },
        { [this.klass]: !!this.klass }
      ]
    },
    containerClasses () {
      return [
        { 'tree-container-ul': true },
        { 'tree-children': true },
        { 'tree-wholerow-ul': !!this.wholeRow },
        { 'tree-no-dots': !!this.noDots }
      ]
    },
    sizeHeight () {
      switch (this.size) {
        case 'large':
          return ITEM_HEIGHT_LARGE + 3
        case 'small':
          return ITEM_HEIGHT_SMALL + 3
        default:
          return ITEM_HEIGHT_DEFAULT + 3
      }
    },
    allNodeTypes () {
      return [].concat(this.nodeType).concat(this.defaultNodeType)
    }
  },
  methods: {
    decideShowNodeTypeIcon (model) {
      let result
      if (model.hasOwnProperty('enableNodeTypeIcon')) {
        result = model.enableNodeTypeIcon
      } else {
        result = this.showNodeTypeIcon
      }
      return !model.loading && result
    },
    readTreeOpenStatusFromCache () {
      this.cacheOpenTreeItems = getOpenTreeItem(this.cacheScope)
      this.$emit('on-open-tree-init', JSON.parse(JSON.stringify(this.cacheOpenTreeItems)))
    },
    initializeData (items) {
      if (items && items.length > 0) {
        for (let i in items) {
          let dataItem = this.initializeDataItem(items[i])
          items[i] = dataItem
          this.initializeData(items[i][this.childrenFieldName])
        }
      }
      if (this.cacheEnable) {
        // this.readTreeOpenStatusFromCache()
      }
    },
    initializeDataItem (item) {
      function Model (item, textFieldName, valueFieldName, childrenFieldName, collapse) {
        this.id = item.id || ITEM_ID++
        this[textFieldName] = item[textFieldName] || ''
        this[valueFieldName] = item[valueFieldName] || item[textFieldName]
        this.icon = item.icon || ''
        this.opened = item.opened || collapse
        this.selected = item.selected || false
        this.disabled = item.disabled || false
        this.loading = item.loading || false
        this[childrenFieldName] = item[childrenFieldName] || []
      }
      let node = Object.assign(new Model(item, this.textFieldName, this.valueFieldName, this.childrenFieldName, this.collapse), item)
      let self = this
      node.addBefore = function (data, selectedNode) {
        let newItem = self.initializeDataItem(data)
        let index = selectedNode.parentItem.findIndex(t => t.id === node.id)
        selectedNode.parentItem.splice(index, 0, newItem)
      }
      node.addAfter = function (data, selectedNode) {
        let newItem = self.initializeDataItem(data)
        let index = selectedNode.parentItem.findIndex(t => t.id === node.id) + 1
        selectedNode.parentItem.splice(index, 0, newItem)
      }
      node.addChild = function (data) {
        let newItem = self.initializeDataItem(data)
        node.opened = true
        node[self.childrenFieldName].push(newItem)
      }
      node.openChildren = function () {
        node.opened = true
        self.handleRecursionNodeChildren(node, node => {
          node.opened = true
        })
      }
      node.closeChildren = function () {
        node.opened = false
        self.handleRecursionNodeChildren(node, node => {
          node.opened = false
        })
      }
      return node
    },
    initializeLoading () {
      let item = {}
      item[this.textFieldName] = this.loadingText
      item.disabled = true
      item.loading = true
      return this.initializeDataItem(item)
    },
    handleRecursionNodeChilds (node, func) {
      if (func(node) !== false) {
        if (node.$children && node.$children.length > 0) {
          for (let childNode of node.$children) {
            if (!childNode.disabled) {
              this.handleRecursionNodeChilds(childNode, func)
            }
          }
        }
      }
    },
    handleRecursionNodeChildren (node, func) {
      if (func(node) !== false) {
        if (node[this.childrenFieldName] && node[this.childrenFieldName].length > 0) {
          for (let childNode of node[this.childrenFieldName]) {
            this.handleRecursionNodeChildren(childNode, func)
          }
        }
      }
    },
    onItemInfoClick (item) {
      this.$emit('on-item-info-click', item)
    },
    onItemClick (oriNode, oriItem, e) {
      if (this.multiple) {
        if (this.allowBatch) {
          this.handleBatchSelectItems(oriNode, oriItem)
        }
      } else {
        this.handleSingleSelectItems(oriNode, oriItem)
      }
      this.selectedItem = oriItem
      this.activeNodeItemIdentify = this.selectedItem[this.nodeIdentifyFieldName]
      this.$emit('item-click', oriNode, oriItem, e)
    },
    onItemDblclick (oriNode, oriItem, e) {
      if (this.multiple) {
        if (this.allowBatch) {
          this.handleBatchSelectItems(oriNode, oriItem)
        }
      } else {
        this.handleSingleSelectItems(oriNode, oriItem)
      }
      this.selectedItem = oriItem
      this.activeNodeItemIdentify = this.selectedItem[this.nodeIdentifyFieldName]
      this.$emit('item-dblclick', oriNode, oriItem)
    },
    handleSingleSelectItems (oriNode, oriItem) {
      this.handleRecursionNodeChilds(this, node => {
        if (node.model) node.model.selected = false
      })
      oriNode.model.selected = true
    },
    handleBatchSelectItems (oriNode, oriItem) {
      this.handleRecursionNodeChilds(oriNode, node => {
        if (node.model.disabled) return
        node.model.selected = oriNode.model.selected
      })
    },
    handleCache () {
      let { filteredData, nodeIdentifyFieldName } = this
      let openedList = []
      const traverse = node => {
        let id = node[nodeIdentifyFieldName]
        let children = node.children || []
        if (node.opened) {
          openedList.push(id)
        }
        children.forEach((child) => {
          let childId = child[nodeIdentifyFieldName]
          if (child.opened) {
            openedList.push(childId)
          }
          traverse(child)
        })
      }
      if (filteredData.length) {
        filteredData.forEach(node => {
          if (node.children && node.children.length) {
            traverse(node)
          }
        })
      }
      setOpenTreeItem(this.cacheScope, Array.from(new Set(openedList)))
    },
    onItemToggle (item) {
      let { opened } = item
      let { nodeIdentifyFieldName } = this
      let id = item[nodeIdentifyFieldName]
      let { filteredData } = this
      if (filteredData.length) {
        const traverse = (node, parentOpenStatus) => {
          const children = node.children || []
          if (parentOpenStatus === false) {
            this.$set(node, 'opened', false)
            children.forEach((child) => {
              traverse(child, false)
            })
          } else {
            if (node[nodeIdentifyFieldName] === id) {
              this.$set(node, 'opened', !opened)
              children.forEach((child) => {
                traverse(child, !opened)
              })
            } else {
              children.forEach((child) => {
                traverse(child, true)
              })
            }
          }
        }
        filteredData.forEach(node => traverse(node, true))
      }
      this.handleCache()
      this.$emit('item-toggle', item)
    },
    handleAsyncLoad (oriParent, oriNode, oriItem) {
      let self = this
      if (this.async) {
        if (oriParent[0].loading) {
          this.async(oriNode, (data) => {
            if (data.length > 0) {
              for (let i in data) {
                if (!data[i].isLeaf) {
                  if (typeof data[i][self.childrenFieldName] !== 'object') {
                    data[i][self.childrenFieldName] = [self.initializeLoading()]
                  }
                }
                let dataItem = self.initializeDataItem(data[i])
                self.$set(oriParent, i, dataItem)
              }
            } else {
              oriNode.model[self.childrenFieldName] = []
            }
          })
        }
      }
    },
    onItemDragStart (e, oriNode, oriItem) {
      if (!this.draggable || oriItem.dragDisabled) { return false }
      e.dataTransfer.effectAllowed = 'move'
      let { dragSuggest, treeType } = this
      if (dragSuggest) {
        e.dataTransfer.setData('nodeName', oriItem.text)
        e.dataTransfer.setData('treeType', treeType)
        e.dataTransfer.setData('parentName', oriItem.parentName)
      }
      this.draggedElm = e.target
      this.draggedItem = {
        item: oriItem,
        parentItem: oriNode.parentItem,
        index: oriNode.parentItem.findIndex(t => t.id === oriItem.id)
      }
      this.$emit('item-drag-start', oriItem)
    },
    onItemDragEnd (e, oriNode, oriItem) {
      this.$emit('item-drag-end', oriItem)
    },
    onItemDrop (e, oriNode, oriItem) {
      if (!this.draggedItem) {
        return false
      }
      if (!this.draggable || !!oriItem.dropDisabled) { return false }
      this.$emit('item-drop-before', oriNode, oriItem, !this.draggedItem ? undefined : this.draggedItem.item, e)
      if (!this.draggedElm || this.draggedElm === e.target || this.draggedElm.contains(e.target)) {
        return
      }
      this.dragOriNode = oriNode
      this.dragOriItem = oriItem
      if (!this.responseServerDrag) {
        this.handleDragData()
      }
      /**
       * 只有拖动目标本身是文件夹类型才允许放置
       */
      if (this.dragOriItem.hasOwnProperty('nodeType') && this.dragOriItem.nodeType === 'folder') {
        if (!this.dragOriItem.opened) {
          this.onItemToggle(this.dragOriItem)
        }
        this.$emit('item-drop', { dragTargetItem: this.dragOriItem, dragOriginItem: this.draggedItem.item })
      } else {
        console.error('The drag target is not folder, drag failed')
      }
      this.draggedItem = null
    },
    handleDragData () {
      if (this.draggedItem) {
        if (this.draggedItem.parentItem === this.dragOriItem[this.childrenFieldName] ||
          this.draggedItem.item === this.dragOriItem ||
          (this.dragOriItem[this.childrenFieldName] && this.dragOriItem[this.childrenFieldName].findIndex(t => t.id === this.draggedItem.item.id) !== -1)) {
          return
        }
        // 先验证容器节点是否有'[childrenFieldName]'属性,没有的话设置属性
        if (!this.dragOriItem.hasOwnProperty(this.childrenFieldName)) {
          this.$set(this.dragOriItem, 'children', [])
        }
        this.draggedItem.item[this.parentFieldName] = this.dragOriItem
        this.dragOriItem[this.childrenFieldName].push(this.draggedItem.item)
        this.dragOriItem.opened = true
        let draggedItem = this.draggedItem
        this.$nextTick(() => {
          draggedItem.parentItem.splice(draggedItem.index, 1)
        })
        if (this.nodeSortFunction) {
          this.nodeSortFunction(this.dragOriItem)
        }
      }
    },
    onContextMenuClick (menuItem) {
      menuItem.basicType = this.basicType
      this.$emit('context-menu-click', menuItem)
    },
    scrollToActiveNoteItem () {
      setTimeout(() => {
        let scrollItem = document.getElementById('treeitem_' + this.activeNodeItemIdentify)
        if (scrollItem) {
          scrollItem.scrollIntoViewIfNeeded(true)
        }
      }, this.scrollIntervalMilliSecond)
    }
  },
  watch: {
    data: {
      handler (val) {
        this.filteredData = val
        let { searchText, value, nodeIdentifyFieldName, cacheScope } = this
        let cacheOpenTreeItems = getOpenTreeItem(cacheScope)
        let selectedNodeId = parseInt(value)
        if (this.filteredData.length) {
          const traverse = node => {
            const children = node.children || []
            children.forEach((child) => {
              let id = child[nodeIdentifyFieldName]
              this.$set(child, 'isSearchMatch', searchText ? child.text.indexOf(searchText) > -1 : false)
              this.$set(child, 'isSelected', id === selectedNodeId)
              this.$set(child, 'opened', cacheOpenTreeItems.indexOf(id) >= 0)
              traverse(child)
            })
            this.$set(node, 'opened', cacheOpenTreeItems.indexOf(node[nodeIdentifyFieldName]) >= 0 || children.some(child => child.opened) || children.some(child => child.isSearchMatch) || children.some(child => child.isSelected))
          }
          this.filteredData.forEach((node, index) => {
            traverse(node)
            if (node[nodeIdentifyFieldName] === 0) {
              this.$set(this.filteredData[index], 'opened', true)
            }
          })
        }
        this.handleCache()
      }
    },
    searchText (val) {
      let { filteredData, hiddenSearchMiss } = this
      if (filteredData.length) {
        const traverse = node => {
          const children = node.children || []
          children.forEach((child) => {
            this.$set(child, 'isSearchMatch', val ? child.text.indexOf(val) > -1 : false)
            this.$set(child, 'opened', val ? child.text.indexOf(val) > -1 : hiddenSearchMiss)
            traverse(child)
          })
          if (children.length) {
            this.$set(node, 'opened', children.some(child => child.isSearchMatch) || children.some(child => child.opened))
            this.$set(node, 'matchLength', val ? children.filter(child => child.isSearchMatch).length : children.length)
          }
        }
        filteredData.forEach(node => traverse(node))
      }
      this.handleCache()
    },
    value (val) {
      let { nodeIdentifyFieldName, cacheScope } = this
      this.activeNodeItemIdentify = val
      let selectedNodeId = parseInt(val)
      if (selectedNodeId > 0) {
        let { filteredData } = this
        if (filteredData.length) {
          const traverse = node => {
            const children = node.children || []
            children.forEach((child) => {
              this.$set(child, 'isSelected', child[nodeIdentifyFieldName] === selectedNodeId)
              traverse(child)
            })
            let cacheOpenTreeItems = getOpenTreeItem(cacheScope)
            if (children.length && (children.some(child => child.isSelected) || children.some(child => child.opened) || cacheOpenTreeItems.indexOf(node[nodeIdentifyFieldName]) >= 0)) {
              this.$set(node, 'opened', true)
            }
          }
          filteredData.forEach(node => traverse(node))
          this.handleCache()
        }
      }
    }
  },
  created () {
    this.initializeData(this.data)
  },
  mounted () {
    this.activeNodeItemIdentify = this.value
    if (this.async) {
      this.$set(this.data, 0, this.initializeLoading())
      this.handleAsyncLoad(this.data, this)
    }
    this.scrollToActiveNoteItem()
  },
  components: {
    TreeItem
  }
}
</script>
<style lang="less">
  @import "./style/style";
  .full-height {
    height: 100%;
  }
  .empty-icon-fill {
    width: 24px;
    display: inline-block;
  }
</style>
